import { resolveFooterCopyright } from './appIdentity';

/**
 * Copy helpers for optional mass-email notifications (tenant-aware).
 */

export function massEmailGreeting(config) {
  const org = String(config?.displayName || config?.branding?.appTitle || 'sindikata').trim();
  return `Pozdravljeni član ali članica ${org}!`;
}

export function massEmailSignoff(config) {
  return resolveFooterCopyright(config);
}

export function massEmailPortalUrl(path = '/') {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${path.startsWith('/') ? path : `/${path}`}`;
  }
  return path;
}
